const OverlayFormName = "DisplayForm";
const DataCollectionForm = "DataCollection";
const TransmitStartResponseActionName = "TransmitStart";
const MultiSelectAccountForm = "LaunchPickerMultiSelect";
function isOverlayDataCollectionPane(responseAction) {
    if (responseAction.Name === OverlayFormName || responseAction.Name === MultiSelectAccountForm) {
        const metadata = responseAction.Metadata;
        if (metadata && metadata.chatFormPanes && metadata.chatFormPanes.length && metadata.chatFormPanes.length >= 1) {
            return metadata.chatFormPanes[0].paneType === DataCollectionForm || metadata.chatFormPanes[0].paneType === MultiSelectAccountForm;
        }
    }
    return false;
}
export function overlayDataCollectionResponse(responseActions) {
    return responseActions && responseActions.find(isOverlayDataCollectionPane);
}
export function getTranmitStartWorkflowResp(responseActions) {
    return responseActions && responseActions.find(responseAction => responseAction.Name === TransmitStartResponseActionName);
}
export function isOverlayResponse(response) {
    return !!(overlayDataCollectionResponse(response.responseActions) || getTranmitStartWorkflowResp(response.responseActions));
}
